import { NgModule } from '@angular/core'

import { CalendarDateFormatter } from 'angular-calendar'

import { CoreModule } from '@undock/core/core.module'
import { UiKitModule } from '@undock/common/ui-kit/ui-kit.module'
import { LayoutModule } from '@undock/common/layout/layout.module'
import { MeetProvider } from '@undock/dock/meet/meet.provider'
import { CalendarGridModule } from '@undock/common/calendar-grid/calendar-grid.module'
import { DashboardRoutingModule } from '@undock/dashboard/dashboard-routing.module'

import {
    DashboardTimelinePageComponent,
    DashboardAttendeeIconsListComponent,
    AttendeesPopupComponent,
    DashboardLayoutComponent,
    TimelineDayViewComponent,
    TimelineEventViewComponent,
    TimelineAllDayEventViewComponent,
    DayViewSkeletonComponent,
    DashboardCalendarPageComponent,
    TimelineEventEditTabsComponent,
    TimelineEventLazyTabsComponent,
    DashboardCalendarEventPopupComponent,
    DashboardCalendarEventDetailsPreviewComponent,
    DashboardCalendarEventDetailsEditComponent,
    DashboardAttendeeListItemComponent,
    DashboardCalendarEventDetailsComponent,
    AllDayEventsListComponent,
    DashboardCalendarEventCardComponent,
    WeekDayViewAvailabilitySlotComponent,
    WeekDayViewReservedSlotComponent,
} from './ui'
import { CalendarBriefsComponent } from './ui/pages/calendar/components/briefs/calendar-briefs.component'
import { DashboardSharedUIModule } from '@undock/dashboard/dashboard-shared-ui.module'
import { TimePromptModule } from '@undock/time/prompt/time-prompt.module'
import { CalendarDateFormatterProvider } from '@undock/common/calendar-grid/services/calendar-date-formatter.provider'


@NgModule({
    imports: [
        CoreModule,
        UiKitModule,
        LayoutModule,

        MeetProvider,
        TimePromptModule,
        DashboardSharedUIModule,
        CalendarGridModule,
        DashboardRoutingModule,
    ],
    exports: [
        DashboardTimelinePageComponent,
        DashboardCalendarPageComponent,
        DashboardCalendarEventCardComponent,
    ],
    declarations: [
        /**
         * Pages
         */
        DashboardCalendarPageComponent,
        DashboardTimelinePageComponent,

        /**
         * Dashboard components
         */
        DashboardLayoutComponent,

        /**
         * Timeline page components
         */
        TimelineDayViewComponent,
        DayViewSkeletonComponent,
        TimelineEventViewComponent,
        TimelineEventEditTabsComponent,
        TimelineEventLazyTabsComponent,
        TimelineAllDayEventViewComponent,

        /**
         * Dashboard page components
         */
        DashboardCalendarEventCardComponent,
        WeekDayViewReservedSlotComponent,
        WeekDayViewAvailabilitySlotComponent,
        DashboardCalendarEventPopupComponent,
        DashboardCalendarEventDetailsComponent,
        DashboardCalendarEventDetailsEditComponent,
        DashboardCalendarEventDetailsPreviewComponent,
        CalendarBriefsComponent,

        /**
         * Shared components
         */
        AttendeesPopupComponent,
        AllDayEventsListComponent,
        DashboardAttendeeListItemComponent,
        DashboardAttendeeIconsListComponent,
    ],
    providers: [
        { provide: CalendarDateFormatter, useClass: CalendarDateFormatterProvider },
    ]
})
export class DashboardUIModule {}
